import { FormControlLabel, Radio } from '@mui/material';
import { useState } from 'react';

import { AgButton } from 'src/components/ui';

import type { FilterItemProps } from './filterItemTypes';

export default function BooleanFilter({ updateFilter, filter, column, onClose }: FilterItemProps) {
  const colName = column.headerName ?? column.field;
  const [value, setValue] = useState<boolean | undefined>(() => {
    const condition = filter.where?.[0]?.equals;
    if (typeof condition === 'boolean') {
      return condition;
    }
    return undefined;
  });
  return (
    <>
      {/* fieldset/legend is the NATIVE group label — no role="radiogroup" needed.
          m-0/border-0/min-w-0 restate the UA defaults a bare <div> already had,
          so this renders pixel-for-pixel what the div did. */}
      <fieldset className="flex flex-col gap-2 p-2 m-0 border-0 min-w-0">
        <legend className="sr-only">{colName}</legend>
        <FormControlLabel
          sx={{ p: 0.5, m: 0, gap: 1, '&:hover': { bgcolor: 'primary.100' } }}
          control={<Radio checked={value === true} size="small" sx={{ py: 0.5, px: 1 }} />}
          label="Yes"
          onChange={() => setValue(true)}
        />
        <FormControlLabel
          sx={{ p: 0.5, m: 0, gap: 1, '&:hover': { bgcolor: 'primary.100' } }}
          control={<Radio checked={value === false} size="small" sx={{ py: 0.5, px: 1 }} />}
          label="No"
          onChange={() => setValue(false)}
        />
      </fieldset>
      <div className="flex justify-between gap-2 p-2 border-t border-neutral-5">
        <AgButton variant="destructive-white" onPress={() => updateFilter({ field: filter.field, where: [] })}>
          Clear
        </AgButton>
        <AgButton
          variant="primary"
          isDisabled={typeof value === 'undefined'}
          onPress={() => {
            updateFilter({ field: filter.field, where: [{ equals: value }] });
            onClose?.();
          }}
        >
          Apply
        </AgButton>
      </div>
    </>
  );
}
